import { defineComponent as _defineComponent } from 'vue'
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import type { Maybe } from '@/helpers/types';

import { computed } from 'vue';
import { SingleTitleSR } from '@/features/sponsored-recommendations/types';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendationImage',
  props: {
    sponsoredAdCampaign: null,
    lazy: { type: Boolean, default: true },
    additionalContexts: { default: () => [] },
    isCinemaSR: { type: Boolean, default: false }
  },
  emits: ["onPosterClickOut", "imageError"],
  setup(__props: any) {

const props = __props as { sponsoredAdCampaign: NonNullable<SponsoredAdFragment['campaign']> & { node: SingleTitleSR }, lazy: boolean, additionalContexts: SnowplowContext[], isCinemaSR: boolean };





const campaignNode = computed(() => props.sponsoredAdCampaign.node);

return { __sfc: true,props, campaignNode }
}

})